module.exports = __webpack_public_path__ + "img/cjzj.d8c80e30.png";